import { useEffect } from "react";
import { Hooks } from "../layout/utils/hooks";
import { useAppSelector } from "../redux/hooks";
import { GlobalHooks } from "../utils/Hooks";

const StatsExportsIntegrated = ({language , token}) => {
  const {cookies} = GlobalHooks()

  const OPTIONS = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Authorization" : "Bearer "+ cookies.authToken,
    },
  };


  const newStatsExportsIframe = "https:" +
    window.process.env.FO_STATS_URL + "/listvideos"
    +  "?lng=" + language + "&token=" +token
  
    return (
      <iframe
        id="iframe_statsExports_display"
        src={newStatsExportsIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsExportsIntegrated